if (!customElements.get('wlsn-buybox-product-options')) {
  class WLSNBuyboxProductOptions extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        option: 'js-wlsn-buybox-product-option',
        loadingState: 'wlsn-loading-state',
        disabled: 'disabled',
      };

      this.bindMethods = {
        onPageUpdated: this._onPageUpdated.bind(this),
      };
    }

    get elements() {
      return {
        options: this.querySelectorAll(`.${this.classes.option}`),
      };
    }

    connectedCallback() {
      const { options } = this.elements;

      if (options) {
        options.forEach((option) => {
          option.addEventListener('click', this._onOptionClick.bind(this));
        });
      }

      // Listen for page updates to remove loading state
      window.addEventListener('wlsn:page:updated', this.bindMethods.onPageUpdated);
    }

    disconnectedCallback() {
      const { options } = this.elements;

      if (options) {
        options.forEach((option) => {
          option.removeEventListener('click', this._onOptionClick);
        });
      }

      window.removeEventListener('wlsn:page:updated', this.bindMethods.onPageUpdated);
    }

    _onOptionClick(event) {
      const { options } = this.elements;
      
      const link = event.target.closest('a');
      if (!link) return;

      const optionHref = link.href;
      if (!optionHref) return;

      // Check if we have a template name in the parent buybox component
      // If not, allow default behavior (full page navigation)
      const buybox = this.closest('wlsn-buybox');
      const templateName = buybox?.getAttribute('data-template-name') || '';
      const isProductPage = buybox?.getAttribute('data-is-product-page') === 'true' && window.location.pathname.startsWith('/products/');
      
      // Only prevent default if we're on a product page OR if we have a valid template name
      if (isProductPage || (templateName && templateName !== 'none')) {
        event.preventDefault();
      } else {
        // No template name and not on product page - allow default navigation
        return;
      }

      // Add loading state to clicked option
      link.classList.add(this.classes.loadingState);

      options.forEach((option) => {
        option.classList.add(this.classes.disabled);
      });

      link.classList.remove(this.classes.disabled);

      const url = new URL(optionHref);

      window.WLSNHelpers.triggerEvent(this, 'wlsn:buybox:product-option-change', { url: url.toString() });
    }

    _onPageUpdated() {
      // Remove loading state from all options after page update
      const { options } = this.elements;
      if (options) {
        options.forEach((option) => {
          option.classList.remove(this.classes.loadingState);
          option.classList.remove(this.classes.disabled);
        });
      }
    }
  }
  customElements.define('wlsn-buybox-product-options', WLSNBuyboxProductOptions);
}
